import { Navigate, useParams } from "react-router-dom";

// /integration/:id/configure was the old edit page. Bookmarks and help
// articles still point at it, so it opens the drawer instead (decision D1).
export default function LegacyConfigureRedirect() {
  const { id } = useParams();
  return <Navigate to={`/integrations?edit=${encodeURIComponent(id)}`} replace />;
}
